import { BaseCarouselTracking } from './BaseCarouselTracking';
import Domain from 'helpers/Domain';

export class BrandsCarouselTracking extends BaseCarouselTracking {
    aalink = [];
    fathom = [];
    element = null;
    carousel_num = 0;
    link = null;
    url = '';
    constructor(aalink, fathom, elem, num, link) {
        super(aalink, fathom, elem, num, link);
        this.aalink = aalink;
        this.fathom = fathom;
        this.element = elem;
        this.carousel_num = num;
        this.link = link;
        this.url = link.getAttribute('href');
    }
    parse() {
        let _carouselId = this.element.getAttribute('data-displayid') ?? '0';

        const obj = {
            carouselId: _carouselId,
            carouselContentType: 'brand',
            carouselModel: 'brand',
            carouselLink: this.url,
            rowHeaderTitle: unescape(this.aalink[3]),
            contentBrand: this.aalink[0],
            posColNum: this.aalink[1].toString(),
            posRowNum: super.getPosRowNum(),
            contentLocked: 0,
            targetURL: this.url,
            screenName: utag_data.screenName,
            discoveryType: 'carousel',
        };

        // START AB Test feature/PLGRWEB-1306-Homepage-endless-scroll-carousel
        const lastAALinkPart = this.aalink[this.aalink.length - 1];
        if (lastAALinkPart.includes('carouselCycle:')) {
            const carouselCycle = lastAALinkPart.split(':');
            obj.slideCycle = carouselCycle[1];
        }
        // END AB Test feature/PLGRWEB-1306-Homepage-endless-scroll-carousel

        super.trackAction(
            Domain.isDomestic() ? 'trackBrandCarouselSelect' : 'trackBrandTileSelect',
            obj,
        );
        return false;
    }
}
